import React, { useEffect, useState } from 'react';
import './Career.css';
import { loadYaml } from '../utilis/loadYAML';
import BifurcatedPromo from '../components/BifurcatedPromo';

interface WorkPoint {
  title: string;
  description: string;
}

interface JobButton {
  text: string;
  link: string;
}

interface Section {
  type: string;
  id?: string;
  title?: string;
  heading?: string;
  description?: string;
  images?: string[];
}

interface CareerConfig {
  title: string;
  bannerImage: string;
  description: string;
  workCulture: WorkPoint[];
  jobsButton: JobButton;
  sections?: Section[];
}

export default function Career() {
  const [data, setData] = useState<CareerConfig | null>(null);

  useEffect(() => {
    loadYaml('/config/Career.yaml').then(setData);
  }, []);

  if (!data) return null;

  return (
    <div className="career-page">
      {/* === Banner Section === */}
      <section
        className="career-banner"
        style={{ backgroundImage: `url(${data.bannerImage})` }}
      >
        <h1 className="career-banner-title">{data.title}</h1>
      </section>


      {/* === Work Culture Section === */}
      <section className="career-culture">
        <h2 className="career-culture-heading">Our Work Culture</h2>
        <div className="career-culture-grid">
          {data.workCulture.map((point, idx) => (
            <div className="career-culture-item" key={idx}>
              <h3>{point.title}</h3>
              <p>{point.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* === Dynamic Optional Sections === */}
      {data.sections?.map((section, idx) => {
        if (section.type === 'bifurcatedPromo') {
          return (
            <React.Fragment key={idx}>
              <hr className="career-section-divider" />
              <BifurcatedPromo
                id={section.id || `career-section-${idx}`}
                title={section.title || ''}
                heading={section.heading || ''}
                description={section.description || ''}
                images={section.images || []}
              />
            </React.Fragment>
          );
        }
        return null;
      })}

      {/* === Jobs CTA Button === */}
      <section className="career-jobs-cta">
        <a href={data.jobsButton.link} className="career-cta-button">
          {data.jobsButton.text}
        </a>
      </section>
    </div>
  );
}
